<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CouponDetail',
})
</script>
<template>
  <div class="coupon">
    <div class="coupon-wrapper">
      <transition-group
        name="mine-coupon-collapse"
        :appear="true"
        v-if="props.coupons.length > 0"
      >
        <div
          class="coupon-card"
          v-for="(coupon, index) in visibleCoupons"
          :key="coupon"
          :style="couponStyle(coupon)"
        >
          <el-checkbox
            v-show="
              (route.path === CREATE_ORDER && !isCouponPending(coupon)) ||
              coupon.checked
            "
            v-model="coupon.checked"
            @change="handleCouponChange(coupon)"
          />
          <div
            class="hasGetCoupon"
            v-if="
              route.path.indexOf('/product/') >= 0 &&
              couponList.data.some((item: any) => item.campaignId === coupon.id)
            "
          >
            <img
              src="https://io-qos.geovisearth.com/getfile/24/dqyun/hasGetCoupon.png"
              alt="已领取"
            />
          </div>
          <div
            v-show="route.path === FINANCIAL_COUPON"
            class="expired-text"
            :class="{
              'expired-used': coupon.useStatus === 1 || coupon.useStatus === 2,
              'expired-soon':
                coupon.useStatus === 0 &&
                timeDifference(coupon.endTime) <= 72 * 60 * 60
            }"
            v-if="
              coupon.useStatus === 1 ||
              coupon.useStatus === 2 ||
              (coupon.useStatus === 0 &&
                timeDifference(coupon.endTime) <= 72 * 60 * 60 &&
                new Date(coupon.startTime.replace(/-/g, '/')) <= new Date())
            "
          >
            <span>{{
              coupon.useStatus === 1
                ? '已使用'
                : coupon.useStatus === 2
                ? '已过期'
                : '即将过期'
            }}</span>
          </div>
          <div class="top">
            <div class="image">
              <!-- 这里放置图片 -->
              <img :src="couponImage(coupon)" alt="优惠券" />
            </div>
            <div class="info">
              <div class="price-condition">
                <span class="money">￥</span>
                <div class="price">{{ coupon.value }}</div>
                <div class="condition">
                  {{ couponCondition(coupon) }}
                </div>
              </div>
              <p class="residue" v-show="route.path.indexOf('/product/') >= 0">
                剩余{{ coupon.residueNum }}张
              </p>
              <div class="time">
                {{ coupon.startTime }} - {{ coupon.endTime }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="bottom">
            <div class="rule">
              <!-- <span>这里是使用规则：</span> -->
              <div
                :class="[
                  'rule-content',
                  isExpanded[index] ? '' : 'rule-hidden',
                  route.path.indexOf(FINANCIAL_COUPON) < 0
                    ? 'rule-two-content'
                    : ''
                ]"
                ref="textContainers"
              >
                使用规则：{{ coupon.info }}
              </div>
            </div>

            <div class="use-button">
              <div
                v-show="isTextOverflow[index]"
                @click="toggleExpanded(index)"
                :class="[
                  'el-dropdown-link',
                  isExpanded[index] ? 'curr' : '',
                  route.path.indexOf('/console/order/createorder/') >= 0
                    ? 'use-button-two'
                    : ''
                ]"
              >
                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </div>

              <el-button
                class="button"
                type="primary"
                v-show="
                  coupon.useStatus === 0 &&
                  new Date(coupon.startTime.replace(/-/g, '/')) <= new Date() &&
                  authenticationSure(coupon) &&
                  route.path === FINANCIAL_COUPON
                "
                @click="useCoupon(coupon)"
                >去使用</el-button
              >
              <el-button
                class="button"
                type="danger"
                v-show="route.path.indexOf('/product/') >= 0"
                @click="handleCouponClick(coupon)"
                >立即领取</el-button
              >
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
  <div class="expand-button-container" @click="collapsed = !collapsed">
    <div
      class="expand-button"
      v-if="collapseCount && props.coupons.length > collapseCount"
    >
      <span>{{ collapsed ? '收起' : '展开全部' }}</span>
      <div :class="['el-dropdown-link', collapsed ? 'curr' : '']">
        <el-icon class="el-icon--right">
          <arrow-down />
        </el-icon>
      </div>
    </div>
  </div>
  <!-- 无数据 -->
  <div class="table-empty" v-if="props.coupons.length <= 0">
    <!-- <img
      src="https://aio-qos.geovisearth.com/getfile/24/dqyun/images/notData.png"
      alt="notData"
    />
    <span>暂无优惠券</span> -->
  </div>
</template>

<script setup lang="ts" name="CouponDetail">
import { FINANCIAL_COUPON, CREATE_ORDER } from '@/router/constant'
import { getCouponApi, getCouponListApi } from '@/api/modules/home'
import { getCommonActivity } from '@/api/modules/product'
import { GlobalStore } from '@/store'

import { authenticationSure } from '@/utils/coupon'
import { isClient } from '@/utils/is'
import { useLoginWithRedirect } from '@/hooks/useLogin'

const globalStore = GlobalStore()
const route = useRoute()
const router = useRouter()

const props = defineProps({
  coupons: {
    type: Object,
    required: true
  },
  collapseCount: {
    type: Number
  }
})

const emit = defineEmits<{
  (e: 'checkedCoupon', params: any[]): void
}>()

let couponList = reactive<{ [key: string]: any }>({ data: [] })
onMounted(async () => {
  if (globalStore.token && route.path.indexOf(FINANCIAL_COUPON) < 0) {
    const { data } = await getCouponListApi({})
    couponList.data = data
  }
})

// 获取使用规则标签
const textContainers = ref<Array<HTMLElement | null>>([])
// 用于记录每个项目的文本是否溢出
const isTextOverflow = ref<boolean[]>([])

// 是否收起
const collapsed = ref(false)
// 展开的优惠券
const visibleCoupons = computed(() => {
  return collapsed.value
    ? props.coupons.map((coupon: { startTime: string; endTime: string }) => {
        coupon.startTime = coupon.startTime.replace(/-/g, '.')
        coupon.endTime = coupon.endTime.replace(/-/g, '.')
        return coupon
      })
    : props.coupons
        .slice(0, props.collapseCount)
        .map((coupon: { startTime: string; endTime: string }) => {
          coupon.startTime = coupon.startTime.replace(/-/g, '.')
          coupon.endTime = coupon.endTime.replace(/-/g, '.')
          return coupon
        })
})

watch(
  () => textContainers,
  () => {
    checkTextOverflow()
  },
  { deep: true }
)

// 展开更多规则
const isExpanded = ref(Array(props.coupons.length).fill(false))
const toggleExpanded = (index: number) => {
  isExpanded.value[index] = !isExpanded.value[index]
}

// 计算时间差
const timeDifference = (endTime: string) => {
  const currentTime = new Date() // 当前时间
  const end = new Date(endTime) // 结束时间
  const timeDifference = end.getTime() - currentTime.getTime() // 计算时间差，单位为毫秒
  const remainingTime = Math.floor(timeDifference / 1000) // 转换为秒数
  return remainingTime // 返回剩余时间，单位为秒
}

//判断优惠券是否待生效
const isCouponPending = (coupon: any) => {
  const currentTime = new Date()
  const start = new Date(coupon.startTime.replace(/-/g, '/'))
  return (
    (coupon.useStatus === 0 && start > currentTime) ||
    coupon.canNotUse ||
    !authenticationSure(coupon)
  )
}

// 判断优惠券的文本是否溢出
const checkTextOverflow = () => {
  textContainers.value.forEach((container, index) => {
    if (container && container.scrollWidth > container.clientWidth) {
      isTextOverflow.value[index] = true
    } else {
      isTextOverflow.value[index] = false
    }
  })
}

// 获取优惠券的样式对象
const couponStyle = (coupon: { checked?: any; useStatus?: any }) => {
  const { useStatus } = coupon
  const isPending =
    isCouponPending(coupon) &&
    !coupon.checked &&
    route.path.indexOf('/product/') < 0

  const style = {
    opacity: useStatus !== 0 ? 0.5 : isPending ? 0.5 : 1,
    filter: useStatus !== 0 ? 'grayscale(100%)' : 'auto'
  }

  return style
}

// 获取优惠券图片
const couponImage = (coupon: any) => {
  return coupon.couponType === 1
    ? 'https://io-qos.geovisearth.com/getfile/24/open/fullamount.png'
    : 'https://io-qos.geovisearth.com/getfile/24/open/orderreduction.png'
}

// 获取优惠券条件
const couponCondition = (coupon: any) => {
  return coupon.couponType === 1
    ? `满${coupon.fullReduction}元可用`
    : '直接抵扣现金'
}

// 去使用优惠券
const useCoupon = async (coupon: any) => {
  const { styleJson } = coupon
  const { productRule, tableList } = JSON.parse(styleJson)
  // 关联商品ids
  const productIdList: number[] = tableList.map(
    (item: { productId: any }) => item.productId
  )
  // standardIds
  const standardIds = tableList.map(
    (item: { standardsId: any }) => item.standardsId
  )
  // 关联商品数量
  const productCount = productIdList.length

  // 跳转活动页
  const redirectToActivityPage = async () => {
    const res = await getCommonActivity()
    if (res.data) {
      router.push({
        path: res.data.url
      })
    }
  }

  // 跳转创建订单页
  const redirectToCreateOrder = (productId: number, standardId: any) => {
    router.push({
      path: CREATE_ORDER,
      query: {
        id: productId,
        standardId: standardId[0]
      }
    })
  }

  // 判断 只有一个商品
  if (productCount === 1 && productRule === 'canProduct') {
    redirectToCreateOrder(productIdList[0], standardIds[0])
  } else {
    redirectToActivityPage()
  }
}
// 领取优惠券
const handleCouponClick = async (coupon: any) => {
  const { ElMessage } = await import('element-plus')
  if (globalStore.token) {
    getCouponApi({ id: coupon.id }).then((res) => {
      if (res.data?.id) {
        couponList.data.push(res.data)
        visibleCoupons.value.forEach((i: { [key: string]: any }) => {
          if (i.id === coupon.id) {
            i.residueNum = res.data.residueNum
          }
        })
        ElMessage({
          type: 'success',
          message: '领取成功'
        })
      } else {
        visibleCoupons.value.forEach((i: { [key: string]: any }) => {
          if (i.id === coupon.id) {
            i.residueNum = res.data?.residueNum || 0
          }
        })
        ElMessage({
          type: 'warning',
          message: res.msg
        })
      }
    })
  } else {
    if (isClient()) {
      // const { skipToLogin } = await import('@dqyun/utils-ssr')
      // skipToLogin()
      useLoginWithRedirect(window.location.href)
    }
  }
}

const checkedCoupons = ref<{ [key: string]: any }[]>([])
const handleCouponChange = (coupon: { [key: string]: any }) => {
  //记录优惠券使用顺序
  if (coupon.checked) {
    if (
      !checkedCoupons.value.some((item) => item.couponId === coupon.couponId)
    ) {
      checkedCoupons.value.push(coupon)
    }
  } else {
    checkedCoupons.value = checkedCoupons.value.filter(
      (item: { [key: string]: any }) => {
        return item.couponId != coupon.couponId
      }
    )
  }
  emit('checkedCoupon', checkedCoupons.value)
}
defineExpose({
  checkedCoupons
})
</script>
<style scoped lang="scss">
.coupon {
  display: flex;
  align-items: center;
}
.expired-text {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 25px;
  padding: 4px 6px;
  background: rgba(222, 64, 64, 1);
  border-radius: 0 4px;
  opacity: 1;

  /** 文本1 */
  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    letter-spacing: 0;
    vertical-align: middle;
  }
}
.coupon-container {
  display: flex;
  justify-content: flex-end;
}
.coupon-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 80%;
}
.coupon-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 352px;
  height: 100%;
  padding: 16px;
  margin-right: 24px;
  margin-bottom: 16px; /* 添加底部间距 */
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 231, 234.6, 1);
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(16, 28, 51, 0.02);
  .el-checkbox {
    position: absolute;
    top: 0;
    right: 15px;
  }
  .hasGetCoupon {
    position: absolute;
    top: 0;
    right: 8px;
    width: 64px;
    height: 64px;
  }
}
.top {
  display: flex;
  width: 100%;
}
.image {
  // display: flex;
  margin-right: 15px;
  opacity: 1;
}
.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}
.price-condition {
  display: flex;
  align-items: flex-end;
  .money {
    /** 文本1 */
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    color: rgba(222, 64, 64, 1);
    letter-spacing: 0;
  }
}
.residue {
  margin: 8px 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  color: #de4040;
  text-align: left;
  letter-spacing: 0;
  vertical-align: middle;
}
.price {
  margin-right: 8px;
  font-size: 28px;
  font-weight: 700;
  line-height: 28px;
  color: rgba(222, 64, 64, 1);
  letter-spacing: 0;
}
.condition {
  font-size: 13px;
  font-weight: 500;
  line-height: 16.41px;
  color: rgba(222, 64, 64, 1);
  letter-spacing: 0;
}
.time {
  width: 100%;
  font-size: 12px;
  color: rgba(145, 152, 168, 1);
}
.divider {
  margin: 12px 0;
  border-top: 1px dashed rgba(145, 152, 168, 0.5);
}
.bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.rule {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  font-size: 14px;
  color: rgba(145, 152, 168, 1);
  .rule-content {
    flex-wrap: wrap;
    width: 207px;
    max-height: 8 * 16px; /* 设置最大高度 */
    overflow: auto; /* 显示滚动条 */
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(145, 152, 168, 1);
    text-align: left;
    letter-spacing: 0;
    vertical-align: middle;
  }
  .rule-two-content {
    flex-wrap: wrap;
    width: 257px;
    max-height: 8 * 16px; /* 设置最大高度 */
    overflow: auto; /* 显示滚动条 */
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(145, 152, 168, 1);
    text-align: left;
    letter-spacing: 0;
    vertical-align: middle;
  }
  .rule-hidden {
    overflow: hidden;
    line-height: 28px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.use-button {
  display: flex; /* 使用flex布局 */
  align-items: center; /* 垂直居中对齐 */
  justify-content: center;
  .el-button--primary {
    width: 74px;
    height: 28px;
    margin-left: 12px;
    background: rgba(51, 133, 255, 1);
    border-radius: 2px;
  }
  .el-button--danger {
    width: 74px;
    height: 28px;
    margin-left: 12px;
    background: rgba(222, 64, 64, 1);
    border-color: rgba(222, 64, 64, 1);
    border-radius: 2px;
  }
  .el-dropdown-link {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 64px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.1s linear;
    .el-icon--right {
      width: 16px;
      height: 16px;
      font-weight: 800px;
      opacity: 0.4;
      transition: all 0.1s linear;
    }
  }
  .el-dropdown-link-two {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 64px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.1s linear;
    .el-icon--right {
      width: 16px;
      height: 16px;
      font-weight: 800px;
      opacity: 0.4;
      transition: all 0.1s linear;
    }
  }
  .el-dropdown-link::after {
    position: absolute;
    bottom: 8px;
    left: 50%;
    display: block;
    width: 0;
    height: 2px;
    content: '';
    transition: all 0.1s;
    transform: translateX(-50%);
  }
  .el-dropdown-link.curr::after {
    display: block;
    width: 100%;
    height: 2px;
    content: '';
    transition: all 0.1s;
  }
  .el-dropdown-link.curr {
    .el-icon--right {
      transition: all 0.1s linear;
      transform: rotate(180deg);
    }
  }
}
.use-button-two {
  display: flex; /* 使用flex布局 */
  align-items: center; /* 垂直居中对齐 */
  justify-content: center;
  height: 28px;
  .el-button--primary {
    width: 74px;
    height: 28px;
    margin-left: 12px;
    background: rgba(51, 133, 255, 1);
    border-radius: 2px;
  }
  .el-button--danger {
    width: 74px;
    height: 28px;
    margin-left: 12px;
    background: rgba(222, 64, 64, 1);
    border-color: rgba(222, 64, 64, 1);
    border-radius: 2px;
  }
  .el-dropdown-link {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 64px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.1s linear;
    .el-icon--right {
      width: 16px;
      height: 16px;
      font-weight: 800px;
      opacity: 0.4;
      transition: all 0.1s linear;
    }
  }
  .el-dropdown-link-two {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 64px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.1s linear;
    .el-icon--right {
      width: 16px;
      height: 16px;
      font-weight: 800px;
      opacity: 0.4;
      transition: all 0.1s linear;
    }
  }
  .el-dropdown-link::after {
    position: absolute;
    bottom: 8px;
    left: 50%;
    display: block;
    width: 0;
    height: 2px;
    content: '';
    transition: all 0.1s;
    transform: translateX(-50%);
  }
  .el-dropdown-link.curr::after {
    display: block;
    width: 100%;
    height: 2px;
    content: '';
    transition: all 0.1s;
  }
  .el-dropdown-link.curr {
    .el-icon--right {
      transition: all 0.1s linear;
      transform: rotate(180deg);
    }
  }
}
.table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  img {
    width: 160px;
    height: 136px;
    margin-top: 10px;
  }
  span {
    width: 70px;
    height: 17px;
    margin-top: 12px;

    /** 文本1 */
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    color: rgba(20, 20, 25, 1);
    text-align: center;
    letter-spacing: 0;
    vertical-align: top;
    opacity: 1;
  }
}
.expired-used {
  background: rgba(204, 204, 204, 1);
}
.expired-soon {
  background: rgba(222, 64, 64, 1);
}
.coupon-collapse-enter-active,
.coupon-collapse-leave-active {
  transition: max-height 0.8s ease-out;
}
.coupon-collapse-enter,
.coupon-collapse-leave-to {
  max-height: 0;
  overflow: hidden;
}
.expand-button-container {
  display: flex;
  align-items: flex-end;
  width: 100%;
}
.expand-button {
  display: flex;
  margin: 0 auto;
  cursor: pointer;
  span {
    font-size: 14px;
    color: rgba(145, 152, 168, 1);
  }
  .el-dropdown-link {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 64px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.1s linear;
    .el-icon--right {
      width: 16px;
      height: 16px;
      font-weight: 800px;
      opacity: 0.4;
      transition: all 0.1s linear;
    }
  }
  .el-dropdown-link::after {
    position: absolute;
    bottom: 8px;
    left: 50%;
    display: block;
    width: 0;
    height: 2px;
    content: '';
    transition: all 0.1s;
    transform: translateX(-50%);
  }
  .el-dropdown-link.curr::after {
    display: block;
    width: 100%;
    height: 2px;
    content: '';
    transition: all 0.1s;
  }
  .el-dropdown-link.curr {
    .el-icon--right {
      transition: all 0.1s linear;
      transform: rotate(180deg);
    }
  }
}
</style>
